export type ToastVariant = "success" | "error" | "warning";

interface ToastProps {
  message: string;
  visible: boolean;
  variant?: ToastVariant;
}

export function Toast({ message, visible, variant = "success" }: Readonly<ToastProps>) {
  if (!visible) return null;

  return (
    <div
      role="status"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] bg-bg-primary text-text-primary px-4 py-3 rounded-2xl text-sm font-medium shadow-[0px_0px_10px_0px_rgba(0,0,0,0.1)] flex items-center gap-3"
    >
      {variant === "success" && (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className="shrink-0">
          <path d="M16 29.333C23.333 29.333 29.333 23.333 29.333 16C29.333 8.667 23.333 2.667 16 2.667C8.667 2.667 2.667 8.667 2.667 16C2.667 23.333 8.667 29.333 16 29.333Z" stroke="var(--color-brand-brown, #a66046)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10.333 16L14.107 19.773L21.667 12.227" stroke="var(--color-brand-brown, #a66046)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
      {variant === "error" && (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className="shrink-0">
          <path d="M16 29.333C23.333 29.333 29.333 23.333 29.333 16C29.333 8.667 23.333 2.667 16 2.667C8.667 2.667 2.667 8.667 2.667 16C2.667 23.333 8.667 29.333 16 29.333Z" stroke="var(--color-system-red, #ea4335)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 12L20 20M20 12L12 20" stroke="var(--color-system-red, #ea4335)" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )}
      {variant === "warning" && (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className="shrink-0">
          <path d="M16 29.333C23.333 29.333 29.333 23.333 29.333 16C29.333 8.667 23.333 2.667 16 2.667C8.667 2.667 2.667 8.667 2.667 16C2.667 23.333 8.667 29.333 16 29.333Z" stroke="var(--color-brand-brown, #a66046)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 10.667V17.333" stroke="var(--color-brand-brown, #a66046)" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M16 21.333H16.013" stroke="var(--color-brand-brown, #a66046)" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )}
      {message}
    </div>
  );
}
